import React from 'react';
import {Grid,Chip} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import {isEmpty} from 'lodash'
import {useSelector, useDispatch} from 'react-redux'
import {onGetMinaChild,getChildKontoUsers,getArtikelTags,getOrderStatusListbyAfid} from 'actions'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      padding: "16px 0px",
    }
  }));
function ChipsList(props) {
    const dispatch = useDispatch()
    const Afid = useSelector(state => state.auth.authUser.user_Afid)
    const userid = useSelector(state => state.auth.authUser.user_id)
    const ChildList = useSelector(state => state.accountsData.ChildList)
    const Userlista = useSelector(state => state.accountsData.Userlista)
    const Kontonamn = useSelector(state => state.accountsData.currentAccount.name)
    const ChildKontoUsers = useSelector(state => state.accountsData.ChildKontoUsers)
    const ArtikelTagsList = useSelector(state => state.ArtikelReg.ArtikelTagsList)
    const OrderStatusList = useSelector(state=>state.accountsData.OrderStatusList)
    const AfDistrikt = useSelector(state => state.accountsData.AfDistrikt)
    const ArendeStatusList = useSelector(state => state.accountsData.ArendeStatusList)
    const NoLabel = props.intl.formatMessage({ id: 'Option.No' });
    const YesLabel = props.intl.formatMessage({ id: 'Option.Yes' });
    const AllLabel = props.intl.formatMessage({ id: 'All' });
    const OrderItemsLabel = props.intl.formatMessage({ id: 'Chips.Order.Items' });
    const EnterpriseLabel = props.intl.formatMessage({ id: 'Enterprise' });
    const ConsumerLabel = props.intl.formatMessage({ id: 'Consumer' });
    const BranchLabel = props.intl.formatMessage({ id: 'Branch' });


    React.useEffect(()=>{
        if(isEmpty(ChildList)){
            dispatch(onGetMinaChild(Afid))
            if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
                const Konto = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
                dispatch(getChildKontoUsers(Afid,userid,Konto))
                dispatch(getOrderStatusListbyAfid(parseInt(Konto) === -1? Afid:Konto,1))
            }
        }
        if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Artikel_Etiketter"}))){
            dispatch(getArtikelTags(Afid,userid))
        }       
    },[])
    const classes = useStyles();
    const GetMeta =(Meta)=>{
        switch(Meta){/*
            case "ansvarig":return "Ansvarig"
            case "Rapport":return "Typ"
            case "DatumFrom":return "Datum från"
            case "DatumTo":return "Datum till"
            case "bokadDatumFrom":return "Bokad datum från"
            case "bokadDatumTo":return "Bokad datum till"
            case "AvbokadDatumFrom":return "Avbokad datum från"
            case "AvbokadDatumTo":return "Avbokad datum till"
            case "StartDatumAvtalFrom":return "Startdatum från"
            case "StartDatumAvtalTo":return "Startdatum till"
            case "StartDatumFrom":return "Periodstart från"
            case "StartDatumTo":return "Periodstart till"
            case "OmforDatumFrom":return "Omför. datum från"
            case "OmforDatumTo":return "Omför. datum till"
            case "ArendeStatus":return "Status"
            case "EsigneringStatus":return "Status"
            case "ArendeFaktura":return "Faktura"
            case "ArendeTyp":return "Typ"
            case "AvtalToken":return "Status"
            case "ProspektToken":return "Status"
            case "Projekt":return <IntlMessages id="Project"/>
            case "KundsTaggar":return "KundsTaggar"
            case "KontonUser":return "Ansvarig"
            case "Kunddatatyp":return "Kunddata"
            case "Konton":return "Konton"
            case "Kundstatus":return "Kundstatus"
            case "OrderStatus":return "Status"
            case "Artikel_Etiketter":return "Artikel etiketter"
            case "MedLopande":return "Med Löpande"
            case "SkapadDatumFrom":return "Skapad datum från"
            case "SkapadDatumTo":return "Skapad datum till"
            case "WithLeverantor":return "Med leverantör"*/
            default:return Meta
        }
    }
    const GetValue =(n)=>{
        const UserObject = Userlista.filter(item=>{return item.id === parseInt(n.Value)})
        switch(n.Meta){
            case "Kundtyp":
                return getKundType(parseInt(n.Value))
            case "Skapad av":
                return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}` 
            case "Ansvarig":
                return `${UserObject[0].FirstName} ${isEmpty(UserObject[0].LastName)?"":UserObject[0].LastName}` 



                
            case "DatumFrom":return  n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "DatumTo":return  n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "bokadDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "bokadDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "AvbokadDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "AvbokadDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumAvtalFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "StartDatumAvtalTo":return moment(n.Value).format("YYYY-MM-DD")
            case "OmforDatumFrom":return moment(n.Value).format("YYYY-MM-DD")
            case "OmforDatumTo":return moment(n.Value).format("YYYY-MM-DD")
            case "SkapadDatumTo":return n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "SkapadDatumFrom":return n.Value!=='Allt'?moment(n.Value).format("YYYY-MM-DD"):n.Value
            case "ArendeStatus":return getArendeStatus(n.Value)
            case "ArendeFaktura":return getArendefaktura(n.Value)
            case "AvtalToken":return getAvtalToken(n.Value)
            case "ProspektToken":return getProspektToken(n.Value)
            case "KundsTaggar":return getKundsTaggar(n.Value)
            case "Konton":return getKontonNamn(n.Value)
            case "KontonUser":return getKontonUser(n.Value)
            case "Artikel_Etiketter":return getArtikelEtiketter(n.Value)
            case "Kundstatus":return getKundstatus(n.Value)
            case "Projekt":return n.Value.ProjectName
            case "Kund":return n.Value.label
            case "Rapport":return getRapportName(n.Value)
            case "OrderStatus":return getOrderStatus(n.Value)
            case "EsigneringStatus":return getEsigneringStatus(n.Value)
            case "MedLopande":return getMedLopande(n.Value)
            case "WithLeverantor":return parseInt(n.Value) === 0?NoLabel:YesLabel
            case "Distrikt":
                if(parseInt(n.Value) === -1){
                    return AllLabel
                }else{
                    try{
                    return AfDistrikt.filter(item=>{return item.id === parseInt(n.Value)})[0].Name
                    }
                    catch(err){
                        return ''
                    }
                }
            default: return `${n.Value}`
        }
    }
   
    const handleDelete=(n)=>{
        props.handleDeleteOptions(n)
    }
    const getRapportName=(Value)=>{
        switch(Value){
            case "Order artiklar":return OrderItemsLabel
            default:return Value
        }
    }
    const getKundType =(Value)=>{
        switch(Value){
            case 1: return EnterpriseLabel
            case 0: return ConsumerLabel
            case 2: return BranchLabel
            case 3: return props.intl.formatMessage({ id: 'Supplier' })
            case 4: return props.intl.formatMessage({ id: 'Resource' })
          }
    }
    const getArendeStatus=(Value)=>{
      if(isEmpty(ArendeStatusList)){
        switch(Value){
          case "1":return props.intl.formatMessage({ id: 'input.status.option1' })
          case "2": return props.intl.formatMessage({ id: 'input.status.option2' })
          case "3": return props.intl.formatMessage({ id: 'input.status.option4' })
          case "4": return props.intl.formatMessage({ id: 'input.status.option5' })
          case "5": return props.intl.formatMessage({ id: 'input.status.option3' })
        }
      }   
      else{   
          //
          let Afif  =Afid
          if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
              Afif = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
          }
          let Sttsta=isEmpty(ArendeStatusList)?[{Meta:""}]:ArendeStatusList.filter(item=>{
              return parseInt(item.Value) === parseInt(Value)
          }) 
          return isEmpty(Sttsta)?"":Sttsta[0].Meta        
      }
    }
    const getArendefaktura=(Value)=>{
      switch(parseInt(Value)){
          case 2: return props.intl.formatMessage({ id:"Errand.Economy.Invoice.option2"})
          case 3: return props.intl.formatMessage({ id:"Errand.Economy.Invoice.option3"})
          case 4: return props.intl.formatMessage({ id:"Errand.Economy.Invoice.option4"})
          case 5: return props.intl.formatMessage({ id:"Errand.Economy.Invoice.option5"})
      }
  }
    const getMedLopande=(Value)=>{
        switch(parseInt(Value)){
            case 1:return YesLabel
            case 2:return NoLabel
            default:return YesLabel
        }
    }
    const getEsigneringStatus=(Value)=>{
        switch(parseInt(Value)){
            case 0: return props.intl.formatMessage({ id:"Created"})
            case 2: return props.intl.formatMessage({ id:"Label.Sent"})
            case 3: return props.intl.formatMessage({ id: 'Label.Shown' })
            case 5: return props.intl.formatMessage({ id: 'Label.Singed' })
            case 1: return props.intl.formatMessage({ id: 'Label.Recalled' })
            case 4: return props.intl.formatMessage({ id: 'Label.Timeout' })
            case 7: return props.intl.formatMessage({ id: 'Label.Rejected' })
            case 6: return props.intl.formatMessage({ id: 'Label.Rejected' })
        }
    }
    const getOrderStatus=(Value)=>{
        if(isEmpty(OrderStatusList)){
            switch(Value){
                case "1": return props.intl.formatMessage({ id: 'Label.Draft' })
                case "2":return props.intl.formatMessage({ id: 'input.status.option1' })
                case "3": return props.intl.formatMessage({ id: 'Order.status.processed' })
                case "4": return props.intl.formatMessage({ id: 'Order.status.supplemented' })
                case "5": return props.intl.formatMessage({ id: 'Order.status.Done' })
            }
            }   
            else{   
                //
                let Afif  =Afid
                if(!isEmpty(props.Chips.filter(item=>{return item.Meta === "Konton"}))){
                    Afif = props.Chips.filter(item=>{return item.Meta === "Konton"})[0].Value
                }
                let Sttsta=isEmpty(OrderStatusList)?[{Meta:""}]:OrderStatusList.filter(item=>{
                    return parseInt(item.Value) === parseInt(Value)
                }) 
                return isEmpty(Sttsta)?"":Sttsta[0].Meta        
            }
        /*
        switch(parseInt(Value)){
            case 1:return "Behandlas"
            case 2:return "Klar"
        }
        */
    }
    const getKundstatus=(Value)=>{
        switch(parseInt(Value)){
            case 1:return <IntlMessages id="Customer.Status1"/>
            case 2:return <IntlMessages id="Customer.Status2"/>
            case 3:return <IntlMessages id="Customer.Status3"/>
            case 4:return <IntlMessages id="Customer.Status4"/>
        }
    }
    const getAvtalToken=(Value)=>{
        switch(parseInt(Value)){
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Completed' })
            case 3:return props.intl.formatMessage({ id: 'All' })
        }
    }
    const getProspektToken=(Value)=>{
        switch(parseInt(Value)){
            case 1:return props.intl.formatMessage({ id: 'Active' })
            case 2:return props.intl.formatMessage({ id: 'Label.Lost' })
            case 4:return props.intl.formatMessage({ id: 'Chips.Deleted' })
            case 3:return props.intl.formatMessage({ id: 'All' })
        }
    }
    const getKundsTaggar=(Value)=>{
        if(Value.toString()  === '-1'){
            return props.intl.formatMessage({ id: 'All' })
        }else{
            return Value
        }
    }
    const getKontonNamn=(Value)=>{
        if(Value.toString()  === '-1'){
            return props.intl.formatMessage({ id: 'All' })
        }
        else if(parseInt(Afid) === parseInt(Value)){
            return Kontonamn
        }
        else{
            console.log(ChildList,"ASD")
            let Konto =isEmpty(ChildList)?"":ChildList.filter(item => {return parseInt(item.ChildAfid) === parseInt(Value)})[0].name
            return Konto
        }
    }
    const getKontonUser=(Value)=>{
        if(Value.toString()  === '-1'){
            return props.intl.formatMessage({ id: 'All' })
        }
        else{
            let Konto = isEmpty(ChildKontoUsers)?"":ChildKontoUsers.filter(item => {return parseInt(item.id) === parseInt(Value)})
            let name = isEmpty(Konto)?"Användare":`${Konto[0].FirstName} ${isEmpty(Konto[0].LastName)?"":Konto[0].LastName}`
            return name
        }
    }
    const getArtikelEtiketter=(Value)=>{
        if(Value.toString()  === '-1'){
            return props.intl.formatMessage({ id: 'All' })
        }
        else{
            let Keyword =isEmpty(ArtikelTagsList)?"":ArtikelTagsList.filter(item => {return parseInt(item.id) === parseInt(Value)})[0].Keyword
            return Keyword
        }
    }
    console.log(props.Chips,"KKJACK")
    return (
        <Grid container className={classes.root} spacing={2}>
            
           {    
                isEmpty(props.Chips)?"":
               props.Chips.map((n,index)=>{
                   return (
                    <Grid item key={index}>
                        <Chip 
                        color="primary" 
                        size="small" 
                        style={{background:n.Type === "dateH"?"#4527a0":"#009688", color:"#fff",borderRadius:"0"}}
                        label={`${GetMeta(n.Meta)}${n.Value >= 0 || isNaN(n.Value)?`: ${GetValue(n)}`:""}`}
                        onDelete={()=>handleDelete(n)} 
                        />
                    </Grid>
                   )
               })
           } 
        </Grid>
    );
}


export default injectIntl(ChipsList);
